import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";
import { HeadingComponent } from "../../heading.component";

export class FormsTabButtonComponent extends EventEmitterMixin(EmptyInstance) {

    public static SELECTOR: string = ".js-ina-form-tabs-button";

    private _currentContext: JQuery = $();
    private _heading: HeadingComponent = null;

    private bindEvents(): void {
        this._currentContext.on("click", e => {
            e.preventDefault();

            this.emit("click", this._heading.getHtml());
        });
    }

    private parseContext(): void {
        const heading = new HeadingComponent();
        heading.init($(HeadingComponent.SELECTOR, this._currentContext));
        this._heading = heading;
    }
    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
